import { render, staticRenderFns } from "./ServiceListDesktop.vue?vue&type=template&id=00d0d4af&scoped=true&"
import script from "./ServiceListDesktop.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ServiceListDesktop.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ServiceListDesktop.vue?vue&type=style&index=0&id=00d0d4af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d0d4af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d0d4af')) {
      api.createRecord('00d0d4af', component.options)
    } else {
      api.reload('00d0d4af', component.options)
    }
    module.hot.accept("./ServiceListDesktop.vue?vue&type=template&id=00d0d4af&scoped=true&", function () {
      api.rerender('00d0d4af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/services/index/components/ServiceListDesktop.vue"
export default component.exports